// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-h6 .q-chip .material-icons {\n  font-size: 1.4em !important;\n}", ""]);
// Exports
module.exports = exports;
